import { CategoryEntity } from '@/domains/business-unit/entities';
import { FindBusinessUnitCategoryUseCase } from '@/domains/business-unit/usecases';
import { useCallback, useState } from 'react';
import { BusinessUnitHttpRepository } from '../adapters/repositories/business-unit.http.repository';

let cachedCategoryList: CategoryEntity[] | null = null;
let categoryListInflight: Promise<CategoryEntity[]> | null = null;

async function fetchCategoryList(): Promise<CategoryEntity[]> {
  if (cachedCategoryList) {
    return cachedCategoryList;
  }
  if (!categoryListInflight) {
    categoryListInflight = (async () => {
      try {
        const findCategoryUsecase = new FindBusinessUnitCategoryUseCase(new BusinessUnitHttpRepository());
        cachedCategoryList = (await findCategoryUsecase.run()) ?? [];
      } catch {
        cachedCategoryList = [];
      }
      return cachedCategoryList;
    })().finally(() => {
      categoryListInflight = null;
    });
  }
  return categoryListInflight;
}

export default function GetCategoryListViewModel() {
  const [categoryList, setCategoryList] = useState<CategoryEntity[]>(cachedCategoryList ?? []);

  const actionFindCategoryList = useCallback(async () => {
    const result = await fetchCategoryList();
    setCategoryList(result);
  }, []);

  return {
    categoryList,
    actionFindCategoryList,
  };
}
